import { render, staticRenderFns } from "./SidebarNestedGroupItem.vue?vue&type=template&id=564f413c&scoped=true&"
import script from "./SidebarNestedGroupItem.vue?vue&type=script&lang=ts&"
export * from "./SidebarNestedGroupItem.vue?vue&type=script&lang=ts&"
import style0 from "./SidebarNestedGroupItem.vue?vue&type=style&index=0&id=564f413c&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "564f413c",
  null
  
)

export default component.exports